import {
  FETCH_QUOTATIONS_BEGIN,
  FETCH_QUOTATIONS_SUCCESS,
  FETCH_QUOTATIONS_FAILURE,
  FETCH_QUOTATION_DETAILS_BEGIN,
  FETCH_QUOTATION_DETAILS_SUCCESS,
  FETCH_QUOTATION_DETAILS_FAILURE,
  CREATE_QUOTATION_CHANGE_REQUEST_BEGIN,
  CREATE_QUOTATION_CHANGE_REQUEST_SUCCESS,
  CREATE_QUOTATION_CHANGE_REQUEST_FAILURE,
  CREATE_QUOTATION_ORDER_BEGIN,
  CREATE_QUOTATION_ORDER_SUCCESS,
  CREATE_QUOTATION_ORDER_FAILURE,
} from "../actions/quotationActions";

import { Quote, QuoteDetails } from "../api/model/quotation";

export interface QuotationListStateLoaded {
  is: "LOADED";
  count: number;
  dateFormat: string;
  quotes: Quote[];
}

export interface QuotationListStateError {
  is: "ERROR";
}

export interface QuotationListStateLoading {
  is: "LOADING";
  count: number;
  dateFormat: undefined | string;
  quotes: Quote[];
}

export type QuotationListState =
  | QuotationListStateLoaded
  | QuotationListStateError
  | QuotationListStateLoading;

export interface QuotationDetailsStateLoaded extends QuoteDetails {
  is: "LOADED";
}

export interface QuotationDetailsStateError {
  is: "ERROR";
}

export interface QuotationDetailsStateLoading {
  is: "LOADING";
}

export type QuotationDetailsState =
  | QuotationDetailsStateLoaded
  | QuotationDetailsStateError
  | QuotationDetailsStateLoading;

export interface QuotationChangeRequestStateLoaded {
  is: "LOADED";
  text: string;
  severity: "I" | "E";
}

export interface QuotationChangeRequestStateError {
  is: "ERROR";
  text: string;
}

export interface QuotationChangeRequestStateLoading {
  is: "LOADING";
}

export type QuotationChangeRequestState =
  | QuotationChangeRequestStateLoaded
  | QuotationChangeRequestStateError
  | QuotationChangeRequestStateLoading;

export interface QuotationOrderStateLoaded {
  is: "LOADED";
  text: string;
}

export interface QuotationOrderStateError {
  is: "ERROR";
  text: string;
}

export interface QuotationOrderStateLoading {
  is: "LOADING";
}

export type QuotationOrderState =
  | QuotationOrderStateLoaded
  | QuotationOrderStateError
  | QuotationOrderStateLoading;

export type QuotationState = {
  errors: Array<{ message }> | { message } | null;
  list: QuotationListState;
  details: {
    [key: string]: QuotationDetailsState;
  };
  orders: {
    [key: string]: QuotationDetailsState;
  };
  changes: {
    [key: string]: QuotationChangeRequestState;
  };
};

const initial: QuotationState = {
  errors: null,
  list: {
    is: "LOADED",
    count: 0,
    dateFormat: undefined,
    quotes: [],
  },
  orders: {},
  details: {},
  changes: {},
};

export default function quotationReducer(state = initial, action) {
  switch (action.type) {
    case FETCH_QUOTATIONS_BEGIN:
      return {
        ...state,
        list: {
          is: "LOADING",
          count: state.list.is !== "ERROR" ? state.list.count : 0,
          dateFormat:
            state.list.is !== "ERROR" ? state.list.dateFormat : undefined,
          quotes: state.list.is !== "ERROR" ? state.list.quotes : [],
        },
      };
    case FETCH_QUOTATIONS_SUCCESS:
      return {
        ...state,
        list: {
          is: "LOADED",
          count: action.payload.totalNoOfQuotes,
          dateFormat: action.payload.dateFormat,
          quotes: action.payload.quotes ? action.payload.quotes : [],
        },
      };
    case FETCH_QUOTATIONS_FAILURE:
      return {
        ...state,
        errors: action.payload.errors,
        list: {
          is: "ERROR",
        },
      };
    case FETCH_QUOTATION_DETAILS_BEGIN:
      return {
        ...state,
        details: {
          ...state.details,
          [action.payload.guid]: {
            is: "LOADING",
          },
        },
      };
    case FETCH_QUOTATION_DETAILS_SUCCESS:
      return {
        ...state,
        details: {
          ...state.details,
          [action.payload.guid]: {
            is: "LOADED",
            ...action.payload.response,
          },
        },
      };
    case FETCH_QUOTATION_DETAILS_FAILURE:
      return {
        ...state,
        details: {
          ...state.details,
          [action.payload.guid]: {
            is: "ERROR",
          },
        },
      };
    case CREATE_QUOTATION_CHANGE_REQUEST_BEGIN:
      return {
        ...state,
        changes: {
          ...state.changes,
          [action.payload.guid]: {
            is: "LOADING",
          },
        },
      };
    case CREATE_QUOTATION_CHANGE_REQUEST_SUCCESS:
      return {
        ...state,
        changes: {
          ...state.changes,
          [action.payload.guid]: {
            is: "LOADED",
            severity: action.payload.response.severity,
            text: action.payload.response.text,
          },
        },
      };
    case CREATE_QUOTATION_CHANGE_REQUEST_FAILURE:
      return {
        ...state,
        changes: {
          ...state.changes,
          [action.payload.guid]: {
            is: "ERROR",
            text: action.payload.error,
          },
        },
      };
    case CREATE_QUOTATION_ORDER_BEGIN:
      return {
        ...state,
        orders: {
          ...state.orders,
          [action.payload.guid]: {
            is: "LOADING",
          },
        },
      };
    case CREATE_QUOTATION_ORDER_SUCCESS:
      return {
        ...state,
        orders: {
          ...state.orders,
          [action.payload.guid]: {
            is: "LOADED",
            text: action.payload.response.text,
          },
        },
      };
    case CREATE_QUOTATION_ORDER_FAILURE:
      return {
        ...state,
        orders: {
          ...state.orders,
          [action.payload.guid]: {
            is: "ERROR",
            text: action.payload.error,
          },
        },
      };
    default:
      return state;
  }
}
